import React from 'react';

interface AdobeLogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  title?: string;
}

export const AdobeLogo: React.FC<AdobeLogoProps> = ({
  className,
  width,
  height,
  style,
  title,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 80 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M14.1687 0H65.8313C73.6594 0 80 6.34111 80 14.17V63.83C80 71.6589 73.6594 78 65.8313 78H14.1687C6.34058 78 0 71.6589 0 63.83V14.17C0 6.34111 6.34058 0 14.1687 0Z"
      fill="#EB1000"
    />
    <path
      d="M62.4566 58.6439H52.9522C52.1145 58.6583 51.3345 58.1672 51.0023 57.3872L40.6889 33.265C40.6167 33.0194 40.3711 32.8894 40.1256 32.9472C39.9811 32.9905 39.8656 33.1061 39.8223 33.2505L33.3944 48.5616C33.2789 48.8361 33.3945 49.1539 33.6834 49.2695C33.7556 49.2983 33.8279 49.3128 33.9001 49.3128H40.9633C41.3966 49.3128 41.8012 49.5728 41.9745 49.9772L45.0656 56.8672C45.3401 57.5172 45.0366 58.2539 44.3866 58.5283C44.2277 58.6005 44.0544 58.6294 43.8955 58.6294H18.1701C17.5201 58.6294 17 58.095 17 57.445C17 57.2861 17.029 57.1272 17.1012 56.9828L33.4667 18.0117C33.8134 17.1739 34.6366 16.625 35.5466 16.625H44.9789C45.8889 16.625 46.7123 17.1594 47.059 18.0117L63.54 56.9828C63.8 57.575 63.5256 58.2683 62.9189 58.5283C62.7745 58.5861 62.63 58.615 62.4711 58.6294"
      fill="white"
    />
  </svg>
);

export default AdobeLogo;
